import { List, Map, Record } from "immutable";

import defaultExposedFilterTypes from "../../../../constants/defaultExposedFilterTypes";
import { ITEM_INSPECTOR_PANEL } from "../../../../constants/identifiers";
import Dimensions from "../../../../constants/styles/dimensions";
import defaultDesktopViewLayout from "../../../../viewLayouts/defaultDesktopViewLayout";
import defaultMobileLandscapeViewLayout from "../../../../viewLayouts/defaultMobileLandscapeViewLayout";
import defaultMobileView from "../../../../viewLayouts/defaultMobileView";
import defaultTabletViewLayout from "../../../../viewLayouts/defaultTabletViewLayout";
import createFromJS from "../../../createFromJS";

export const AppStateRecord = Record({
  selectedItems: List(),
  selectedMarkers: List(),
  selectedSyncItems: List(),
  desktopOpenViews: defaultDesktopViewLayout,
  tabletOpenViews: defaultTabletViewLayout,
  mobileLandscapeOpenViews: defaultMobileLandscapeViewLayout,
  mobileView: defaultMobileView,
  scrollingIsLocked: true,
  ignoredNotifications: List(),
  leftPanelMode: null, // String
  tabletPanelMode: null,
  mobilePanelMode: null,
  rightPanelMode: ITEM_INSPECTOR_PANEL,
  visibleTypeList: null, // String
  tabletVisibleTypeList: null,
  mobileVisibleTypeList: null,
  leftPanelWidth: Dimensions.MAX_LEFT_PANEL_WIDTH,
  rightPanelWidth: Dimensions.DEFAULT_RIGHT_PANEL_WIDTH,
  inspectorTab: 0,
  notificationTab: 0,
  syncTab: 0,
  suggestionGroups: List(),
  completedSuggestionGroups: List(),
  expandedSyncItems: List(),
  expandedEntityItems: Map(),
  expandedFilterGroups: Map(),
  excludeSearchTypes: List(),
  disableTimelineZoom: false,
  disableSplitView: false,
  disableFiltering: false,
  disableFilteringMore: false,
  fontPercentage: 100,
  exposedFilterTypes: defaultExposedFilterTypes
});

const data = {
  objects: {
    desktopOpenViews: "OpenViewsRecord",
    tabletOpenViews: "OpenViewsRecord",
    mobileLandscapeOpenViews: "OpenViewsRecord",
    mobileView: "MobileViewRecord",
    selectedItems: "List",
    selectedMarkers: "List",
    selectedSyncItems: "List",
    ignoredNotifications: "List",
    completedSuggestionGroups: "List",
    expandedSyncItems: "List",
    expandedEntityItems: "Map",
    expandedFilterGroups: "Map",
    excludeSearchTypes: "List",
    exposedFilterTypes: "List"
  },
  collections: {
    suggestionGroups: "SuggestionGroupRecord"
  }
};
createFromJS.registerCallback("AppStateRecord", createFromJS.createNestedCallback(AppStateRecord, data));
